import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISponsorshipType } from "../sponsorshiptypeModel";

export const getAllSponsorshipType = createAsyncThunk(
  "SponsorshipType/FindAllSponsorshipType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SponsorshipType/FindAllSponsorshipType`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSponsorshipTypeByID = createAsyncThunk(
  "SponsorshipType/FindByIDSponsorshipType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SponsorshipType/FindByIDSponsorshipType`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Title: result?.Title,
        IsActive: result?.IsActive ? 1 : 2,
      } as ISponsorshipType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSponsorshipType = createAsyncThunk(
  "SponsorshipType/FindAllActiveSponsorshipType",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SponsorshipType/FindAllActiveSponsorshipType`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSponsorshipType = createAsyncThunk(
  "SponsorshipType/InsertSponsorshipType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SponsorshipType/InsertSponsorshipType`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSponsorshipType = createAsyncThunk(
  "SponsorshipType/UpdateSponsorshipType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SponsorshipType/UpdateSponsorshipType`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const sponsorshipTypeActiveInactive = createAsyncThunk(
  "SponsorshipType/ActiveInActiveSponsorshipType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SponsorshipType/ActiveInActiveSponsorshipType`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSponsorshipType = createAsyncThunk(
  "SponsorshipType/DeleteSponsorshipType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SponsorshipType/DeleteSponsorshipType`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting SponsorshipType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
